<main class="main">
  <div class="content">
    <router-outlet />
  </div>
</main>
